import { Theme } from "app/umbraco/models/settings.model";

export default (theme?: Theme, variant?: any, width?: any): string[] => {
    const classes = [];

    // Settings classes
    if (width && width.length > 0 && width === "Narrow") {
        classes.push(`button-width--${width}`);
    }
    else if (width && width.length > 0 && width === "Wide") {
        classes.push(`button-width--${width}`);
    }
    else if (width && width.length > 0 && width === "Full") {
        classes.push(`button-width--${width}`);
    }
    else {
        classes.push("");
    }


    // Theme classes
    if (variant && variant.toUpperCase() === "SECONDARY" && theme?.secondaryButton?.[0]?.content?.["_contentType"]) {
        if (theme?.secondaryButton?.[0]?.content?.buttonWidth === "Narrow") {
            classes.push(`button-theme-width--${theme?.secondaryButton?.[0]?.content?.buttonWidth}`);
        }
        else if (theme?.primaryButton?.[0]?.content?.buttonWidth === "Full") {
            classes.push(`button-theme-width--${theme?.primaryButton?.[0]?.content?.buttonWidth}`);
        }
    }
    else if (variant && variant.toUpperCase() === "TERTIARY" && theme?.tertiaryButton?.[0]?.content?.["_contentType"]) {
        if (theme?.tertiaryButton?.[0]?.content?.buttonWidth === "Narrow") {
            classes.push(`button-theme-width--${theme?.tertiaryButton?.[0]?.content?.buttonWidth}`);
        }
        else if (theme?.tertiaryButton?.[0]?.content?.buttonWidth === "Full") {
            classes.push(`button-theme-width--${theme?.tertiaryButton?.[0]?.content?.buttonWidth}`);
        }
    }
    else if (variant && variant.toUpperCase() === "ARROW" && theme?.arrowButton?.[0]?.content?.["_contentType"]) {
        if (theme?.arrowButton?.[0]?.content?.buttonWidth === "Narrow") {
            classes.push(`button-theme-width--${theme?.arrowButton?.[0]?.content?.buttonWidth}`);
        }
        else if (theme?.arrowButton?.[0]?.content?.buttonWidth === "Full") {
            classes.push(`button-theme-width--${theme?.arrowButton?.[0]?.content?.buttonWidth}`);
        }
    }
    else if (theme?.primaryButton?.[0]?.content?.buttonWidth) {
        classes.push(`button-theme-width--${theme?.primaryButton?.[0]?.content?.buttonWidth}`);
    }

    return classes;
};
